// src/theme/typography.js

/**
 * Typography configuration for Aghrba theme
 * Uses Playfair Display for headings and Poppins for body text
 */
export const typography = {
  fontFamily: 'Poppins, system-ui, -apple-system, sans-serif',
  h1: {
    fontFamily: '"Playfair Display", serif',
    fontWeight: 700,
    fontSize: '2.5rem',
    letterSpacing: '0.02em',
  },
  h2: {
    fontFamily: '"Playfair Display", serif',
    fontWeight: 700,
    fontSize: '2rem',
    letterSpacing: '0.02em',
  },
  h3: {
    fontFamily: '"Playfair Display", serif',
    fontWeight: 600,
    fontSize: '1.75rem',
  },
  h4: {
    fontFamily: '"Playfair Display", serif',
    fontWeight: 600,
    fontSize: '1.5rem',
  },
  h5: {
    fontWeight: 600,
    fontSize: '1.25rem',
  },
  h6: {
    fontWeight: 600,
    fontSize: '1rem',
  },
  subtitle1: {
    fontSize: '1rem',
    fontWeight: 500,
  },
  subtitle2: {
    fontSize: '0.875rem',
    fontWeight: 500,
  },
  body1: {
    fontSize: '1rem',
    lineHeight: 1.6,
  },
  body2: {
    fontSize: '0.875rem',
    lineHeight: 1.6,
  },
  button: {
    fontSize: '0.875rem',
    fontWeight: 600,
    textTransform: 'none',
  },
  caption: {
    fontSize: '0.75rem',
  },
  overline: {
    fontSize: '0.75rem',
    letterSpacing: '0.1em',
    textTransform: 'uppercase',
  },
};

// Typography tokens for consistent styling
export const typographyTokens = {
  // Gradient text styles
  gradientText: (theme) => ({
    background: theme.aghrba.gradients.goldText,
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    backgroundClip: 'text',
    color: 'transparent',
    display: 'inline-block',
  }),
  
  // Font combinations
  heading: {
    primary: '"Playfair Display", serif',
    secondary: '"Poppins", sans-serif',
  },
  
  // Common styles
  lineClamp: (lines) => ({
    display: '-webkit-box',
    WebkitLineClamp: lines,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
  }),
  
  ellipsis: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
};